import { useLocation } from 'react-router-dom'
import { getLangFromPathname, localizePath as localizePathUtil, type LangCode } from '@/utils/localeFromUrl'

/**
 * Current language from URL and helper to build localized paths.
 */
export function useLocale(): { lang: LangCode; localizePath: (path: string) => string } {
  const { pathname } = useLocation()
  const lang = getLangFromPathname(pathname)
  const localizePath = (path: string) => localizePathUtil(lang, path)
  return { lang, localizePath }
}
